import * as React from 'react';

function SvgActClose(props) {
    return (
        <svg
            viewBox="0 0 128 128"
            {...props}
        >
            <g fill="currentColor">
                <path d="M102.66 25.37a54.25 54.25 0 100 76.76 54.34 54.34 0 000-76.76zm-5.94 70.81a45.87 45.87 0 110-64.87 45.92 45.92 0 010 64.87z" />
                <path d="M82.4 75.37L70.49 63.49 82.4 51.6a4.21 4.21 0 10-6-6L64.54 57.54 52.63 45.65a4.21 4.21 0 00-6 6l11.96 11.84-11.91 11.88a4.21 4.21 0 006 5.95l11.86-11.89 11.91 11.89a4.21 4.21 0 106-5.95z" />
            </g>
        </svg>
    );
}

export default SvgActClose;
